module.exports = __webpack_public_path__ + "static/Laura-Fernandes-2bd24b2fad0f619d7d5402aeac39ca4c.jpg";